import { Component, EventEmitter, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-header-demanda-inducida',
  templateUrl: './header-demanda-inducida.component.html',
  styleUrls: ['./header-demanda-inducida.component.css']
})
export class HeaderDemandaInducidaComponent implements OnInit {

  @Output() public generar: EventEmitter<boolean> = new EventEmitter<boolean>();

  constructor() { }

  ngOnInit() {
  }

  public onGenerar() {
    this.generar.emit(true);
  }

  public onImprimir() {
    let printContents: any, popupWin: any;
    printContents = document.getElementById('reporte-demanda-inducida').innerHTML;
    popupWin = window.open('', '_blank', 'top=0,left=0,height=100%,width=auto, menubar=yes,location=yes,resizable=yes,scrollbars=yes,status=yes');
    popupWin.document.open();

    popupWin.document.write(`
      <html>
        <head>
          <title> Standard Health | Demanda Inducida </title>
          <link rel="stylesheet" href="https://stackpath.bootstrapcdn.com/bootstrap/4.1.3/css/bootstrap.min.css" integrity="sha384-MCw98/SFnGE8fJT3GXwEOngsV7Zt27NXFoaoApmYm81iuXoPkFOJwJ8ERdknLPMO" crossorigin="anonymous">
          <style>
            /* Tamaños fuentes */

            .font-title {
                font-size: 150px;
            }

            .font-subtitle {
                font-size: 30px;
            }

            .font-normal {
                font-size: 16px;
            }

            .table-no-border,
            .table-no-border td,
            .table-no-border th {
                border: none !important;
            }

          </style>
        </head>
        <body onload="window.print();window.close()">${ printContents}</body>
      </html>`
    );
    popupWin.document.close();
  }

}
